(function() {
  'use strict';

  var STORAGE_KEY = 'adn_email_captured';
  var DISCOUNT_CODE = 'ADN10';

  function isSubscribed() {
    var flag = document.getElementById('adn-customer-subscribed');
    if (flag && flag.dataset.subscribed === 'true') return true;
    return localStorage.getItem(STORAGE_KEY) === '1';
  }

  function buildCaptureHTML() {
    return '<div id="adn-capture-box" style="margin:0 0 12px 0;padding:14px 16px;background:#fff9f5;border:1px solid #e8d5c4;border-radius:8px;font-family:inherit;">'
      + '<p style="margin:0 0 2px 0;font-size:15px;font-weight:700;color:#1a1a1a;">10% de descuento en tu compra!</p>'
      + '<p style="margin:0 0 10px 0;font-size:13px;color:#444;">Ingresa tu correo y recibe 10% de descuento para usar en este pedido.</p>'
      + '<div style="display:flex;gap:6px;">'
      + '<input id="adn-email-input" type="email" placeholder="tu@correo.com" autocomplete="email" style="flex:1;padding:8px 10px;font-size:13px;border:1px solid #ccc;border-radius:6px;outline:none;min-width:0;"/>'
      + '<button id="adn-capture-btn" style="padding:8px 14px;background:#1a1a1a;color:#fff;border:none;border-radius:6px;font-size:13px;cursor:pointer;white-space:nowrap;">Quiero mi 10%</button>'
      + '</div>'
      + '<p id="adn-capture-error" style="display:none;margin:6px 0 0;font-size:12px;color:#c0392b;"></p>'
      + '<p style="margin:8px 0 0;font-size:11px;color:#999;">Te avisaremos primero sobre nuevos colores, restocks y beneficios exclusivos.</p>'
      + '</div>';
  }

  function buildSuccessHTML() {
    return '<div id="adn-capture-box" style="margin:0 0 12px 0;padding:14px 16px;background:#f0f9f0;border:1px solid #b8ddb8;border-radius:8px;font-family:inherit;">'
      + '<p style="margin:0 0 4px 0;font-size:14px;font-weight:700;color:#1a1a1a;">¡Tu descuento está listo!</p>'
      + '<p style="margin:0 0 10px 0;font-size:12px;color:#444;">Copia el código y úsalo al finalizar tu compra:</p>'
      + '<div style="display:flex;align-items:center;gap:8px;">'
      + '<div style="padding:7px 14px;background:#1a1a1a;color:#fff;border-radius:4px;font-size:13px;font-weight:700;letter-spacing:1.5px;">' + DISCOUNT_CODE + '</div>'
      + '<button id="adn-copy-btn" style="padding:7px 12px;background:#fff;color:#1a1a1a;border:1px solid #ccc;border-radius:4px;font-size:12px;cursor:pointer;white-space:nowrap;">Copiar</button>'
      + '</div>'
      + '</div>';
  }

  function attachCopyListener(box) {
    var btn = box.querySelector('#adn-copy-btn');
    if (!btn) return;
    btn.addEventListener('click', function() {
      navigator.clipboard.writeText(DISCOUNT_CODE).then(function() {
        btn.textContent = '¡Copiado!';
        btn.style.borderColor = '#27ae60';
        btn.style.color = '#27ae60';
        setTimeout(function() {
          btn.textContent = 'Copiar';
          btn.style.borderColor = '#ccc';
          btn.style.color = '#1a1a1a';
        }, 2000);
      });
    });
  }

  function attachListeners(box) {
    var btn = box.querySelector('#adn-capture-btn');
    var input = box.querySelector('#adn-email-input');
    var errEl = box.querySelector('#adn-capture-error');

    function onSubmit() {
      var email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errEl.textContent = 'Por favor ingresa un correo válido.';
        errEl.style.display = 'block';
        return;
      }
      errEl.style.display = 'none';
      btn.disabled = true;
      btn.textContent = '...';

      var formData = new FormData();
      formData.append('form_type', 'customer');
      formData.append('utf8', '✓');
      formData.append('contact[email]', email);
      formData.append('contact[tags]', 'adn-cart-capture');
      formData.append('customer[accepts_marketing]', 'true');

      fetch('/contact', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      })
        .then(function(res) {
          if (res.ok || res.redirected) {
            localStorage.setItem(STORAGE_KEY, '1');
            var parent = box.parentNode;
            if (parent) {
              var tmp = document.createElement('div');
              tmp.innerHTML = buildSuccessHTML();
              var successBox = tmp.firstElementChild;
              parent.insertBefore(successBox, box);
              parent.removeChild(box);
              attachCopyListener(successBox);
            }
          } else {
            throw new Error('server error');
          }
        })
        .catch(function() {
          btn.disabled = false;
          btn.textContent = 'Quiero mi 10%';
          errEl.textContent = 'Algo falló, intenta de nuevo.';
          errEl.style.display = 'block';
        });
    }

    btn.addEventListener('click', onSubmit);
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') onSubmit();
    });
  }

  var injectScheduled = false;

  function scheduleInject() {
    if (injectScheduled) return;
    injectScheduled = true;
    setTimeout(function() {
      injectScheduled = false;
      injectCaptureBox();
    }, 120);
  }

  function injectCaptureBox() {
    if (isSubscribed()) return;
    if (document.getElementById('adn-capture-box')) return;

    var content = document.querySelector('.cart-drawer__content');
    if (!content) return;

    var dialog = document.querySelector('cart-drawer-component dialog');
    if (!dialog || !dialog.hasAttribute('open')) return;

    var tmp = document.createElement('div');
    tmp.innerHTML = buildCaptureHTML();
    var box = tmp.firstElementChild;
    content.insertBefore(box, content.firstChild);
    attachListeners(box);
  }

  document.addEventListener('cart:update', scheduleInject);

  var observer = new MutationObserver(function(mutations) {
    var drawerOpen = !!document.querySelector('cart-drawer-component dialog[open]');
    if (!drawerOpen) return;

    var boxGone = !document.getElementById('adn-capture-box');
    var hadRelevantMutation = mutations.some(function(m) {
      return m.type === 'childList' && m.removedNodes.length > 0;
    });

    if (boxGone && hadRelevantMutation) {
      scheduleInject();
    }

    mutations.forEach(function(m) {
      if (m.type === 'attributes' && m.attributeName === 'open') {
        if (m.target.hasAttribute('open')) {
          scheduleInject();
        }
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    var drawerEl = document.querySelector('cart-drawer-component');
    if (drawerEl) {
      observer.observe(drawerEl, {
        attributes: true,
        attributeFilter: ['open'],
        subtree: true,
        childList: true,
      });
    }
  });

})();
